import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  // DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  Row,
  Select,
  Space,
  Table,
  // Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useRef, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { getRequest, patchRequest } from "../../axios";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import { ErrorNotificationMsg } from "../../utils/Notifications";

import {
  DownloadOutlined,
  FilterOutlined,
  InsertRowLeftOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import moment from "moment";

const { Option } = Select;
const BillingReportAdmin = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const colors = useMemo(() => ["#737373"], []);
  // const colors = ["#737373"];
  const [driverForm] = Form.useForm();
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [btnLoading, setBtnLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [driverList, setDriverList] = useState([]);
  const formRef = useRef();
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });
  const intialFilter = {
    state: "",
    zone_id: [],
    suburb_id: [],
    driver_id: "",
    status: "",
  };
  const [stateFilter, setStateFilter] = useState(intialFilter);

  useEffect(() => {
    const getEmployeeList = async () => {
      setLoading(true);

      const queryParamsObject = {
        ...state,
        // start_date: startDate || null,
        // end_date: endDate || null,
        // state: stateFilter?.state || null,
        // driver_id: stateFilter?.driver_id || null,
        // status: stateFilter?.status || null,
        page: state.page,
        ordering: state.ordering,
        pagesize: state.pagesize,
        search: state.search,
        total: state.total,
      };

      const queryParams = new URLSearchParams(
        Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
          if (value !== null && value !== undefined) {
            acc[key] = value;
          }
          return acc;
        }, {})
      ).toString();

      try {
        const apiResponse = await getRequest(
          // `return-driver-report/driver-report-filter/?${queryParams}`,
          `billing-report/billing-report/?${queryParams}`
        );

        if (apiResponse.data.success) {
          setEmployeeList(apiResponse.data.data);
          settotalCount(apiResponse.data.count);
        }
      } catch (error) {
        ErrorNotificationMsg(t("Error fetching employee list"));
      } finally {
        setLoading(false);
      }
    };

    getEmployeeList();
  }, [state, t]);
  // }, [state, t]);

  const [checkedList, setCheckedList] = useState([
    "invoice_month",
    "trend",
    "total_amount",
    "total_recharge",
    "total_sales",
  ]);

  const [columns, setColumns] = useState([]);
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  useEffect(() => {
    const updatedColumns = [
      // Define columns here
      {
        title: "Month",
        dataIndex: "invoice_month",
        key: "invoice_month",
        sorter: true,
        width: 100,
        render: (monthNumber) => monthNames[monthNumber - 1] || "Invalid Month",
      },
      {
        title: "Total Sales",
        dataIndex: "total_sales",
        key: "total_sales",
        sorter: true,
        width: 100,
      },

      {
        title: "Total Recharge",
        dataIndex: "total_recharge",
        key: "total_recharge",
        sorter: true,
        width: 100,
      },

      {
        title: "Total Amount",
        dataIndex: "total_amount",
        key: "total_amount",
        sorter: true,
        width: 100,
      },

      {
        title: "Trend",
        dataIndex: "trend",
        key: "trend",
        sorter: true,
        width: 100,
      },
    ].filter((column) => checkedList.includes(column.key));
    setColumns(updatedColumns);
  }, [checkedList, driverList, t, colors]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };
  const columnMenu = (
    <Menu>
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            <Col span={12}>
              <Checkbox value="invoice_month">Month</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="total_sales">Total Sales</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="total_recharge">Total Recharge</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="total_amount">Total Amount</Checkbox>
            </Col>
            <Col span={12}>
              <Checkbox value="trend">Trend</Checkbox>
            </Col>
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  useEffect(() => {
    const getDeliveryStatus = async () => {
      try {
        const response = await getRequest("billing-report/billing-report/");
        const { data } = response.data;

        setDriverList(data);
        formRef.current.setFieldsValue(response.data.data);
      } catch (error) {
        // setapiLoading(false);
      }
    };
    getDeliveryStatus();
  }, [state, t]);

  const handleDriverFilter = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      driver_id: value,
    }));
  };

  const handleDeliveryStatus = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      status: value,
    }));
  };

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });

    if (selectedRow.length === 0) {
      driverForm.resetFields(); // Reset the driver form fields
    }
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "invoice_month" && sortOrder === "ascend") {
      sortingEnumKey = "invoice_month";
    }
    if (sortField === "invoice_month" && sortOrder === "descend") {
      sortingEnumKey = "-invoice_month";
    }

    if (sortField === "total_sales" && sortOrder === "ascend") {
      sortingEnumKey = "total_sales";
    }
    if (sortField === "total_sales" && sortOrder === "descend") {
      sortingEnumKey = "-total_sales";
    }
    if (sortField === "total_recharge" && sortOrder === "ascend") {
      sortingEnumKey = "total_recharge";
    }
    if (sortField === "total_recharge" && sortOrder === "descend") {
      sortingEnumKey = "-total_recharge";
    }

    if (sortField === "total_amount" && sortOrder === "ascend") {
      sortingEnumKey = "total_amount";
    }
    if (sortField === "total_amount" && sortOrder === "descend") {
      sortingEnumKey = "-total_amount";
    }

    if (sortField === "trend" && sortOrder === "ascend") {
      sortingEnumKey = "trend";
    }
    if (sortField === "trend" && sortOrder === "descend") {
      sortingEnumKey = "-trend";
    }

    return sortingEnumKey;
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };

  const handleApplyFilter = async () => {
    setState({
      // ...state,
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
  };
  const handleStartDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setStartDate(formattedDate);
  };

  const handleEndDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    setEndDate(formattedDate);
  };

  const minEndDate = startDate
    ? moment(startDate, "DD-MM-YYYY").startOf("day")
    : null;

  const handleResetFilter = () => {
    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
    setStateFilter(intialFilter);

    form.setFieldsValue({ search: "" });
    setStartDate(null);

    formRef.current.setFieldsValue({
      state: undefined,
      zone: undefined,
      suburb: undefined,
      start_date: undefined,
      end_date: undefined,
      status: undefined,
      driver_id: undefined,
    });
  };
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRow(selectedRowKeys);

      if (selectedRowKeys.length === 0) {
        driverForm.resetFields();
      }
    },
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow?.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);

      if (updatedSelectedRowKeys?.length === 0) {
        driverForm.resetFields();
      }
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow?.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);

      if (updatedSelectedRowKeys?.length === 0) {
        driverForm.resetFields();
      }
    },
    selectedRowKeys: selectedRow,
  };

  // const downloadCSV = async () => {
  //   // const endpoint = `return-driver-report/driver-report-excel-download/`;
  //   const endpoint = `return-driver-report/driver-report-excel-download/`;
  //   const fileType = "csv";

  //   try {
  //     await getRequest(endpoint).then((response) => {
  //       const blob = new Blob([response.data], {
  //         type: "text/csv",
  //       });
  //       const link = document.createElement("a");
  //       link.href = window.URL.createObjectURL(blob);
  //       link.download = `LateReturnReport${+new Date()}.${fileType}`;
  //       link.click();
  //     });
  //   } catch (error) {
  //     if (error.response && error.response.status === 404) {
  //       console.error("File not found or endpoint is incorrect.");
  //     } else {
  //       console.error("Error downloading the file:", error);
  //     }
  //   }
  // };

  const downloadCSV = async () => {
    setBtnLoading(true);
    const endpoint = `billing-report/billing-report-pdf/`;
    const fileType = "pdf";

    try {
      // Use patchRequest instead of getRequest
      const response = await getRequest(`${endpoint}`);

      // Process the downloaded file as CSV
      const blob = new Blob([response.data], {
        type: "text/pdf",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `BillingReport${+new Date()}.${fileType}`;
      link.click();
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
      if (error.response && error.response.status === 404) {
        console.error("File not found or endpoint is incorrect.");
        setBtnLoading(false);
      } else {
        console.error("Error downloading the file:", error);
        setBtnLoading(false);
      }
    }
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View & Manage The List Of Packages Within The Organization.
                </span>
              }
            > */}
            <h3>{t("Billing Report")}</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Billing Report")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              ""
            )}

            <div className="gridiconswrap">
              <Button
                className="SaveGradiantBtn"
                type="primary"
                htmlType="DownloadPDF"
                onClick={downloadCSV}
                loading={btnLoading}
                style={{ width: "80%" }}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <DownloadOutlined style={{ fontSize: "16px" }} /> Download PDF
                </span>
              </Button>
              <Dropdown
                overlay={columnMenu}
                trigger={["click"]}
                placement="bottomRight"
                overlayClassName="customdropdwn"
                visible={dropdownVisible}
                onVisibleChange={(visible) => setDropdownVisible(visible)}
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<InsertRowLeftOutlined />}
                  onClick={() => setDropdownVisible(!dropdownVisible)}
                />
              </Dropdown>
            </div>
            {/* </Tooltip> */}
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="Package-body">
          {/* <div className="filterrow packagefilter">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef}>
                <Space wrap>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="start_date"
                      label={t("pl_min_date")}
                      rules={[
                        {
                          required: false,
                          message: <Trans>{t("val_start_date")}</Trans>,
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        allowClear={false}
                        onChange={handleStartDateChange}
                        style={{ width: "140px" }}
                        placeholder={t("statr_date")}
                      />
                    </Form.Item>
                  </Col>

                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="end_date"
                      label={t("pl_max_date")}
                      rules={[
                        {
                          required: false,
                          message: <Trans>{t("val_end_date")}</Trans>,
                        },
                      ]}
                    >
                      <DatePicker
                        format="DD-MM-YYYY"
                        allowClear={false}
                        onChange={handleEndDateChange}
                        style={{ width: "140px" }}
                        placeholder={t("end_date")}
                        disabled={!startDate}
                        disabledDate={(current) =>
                          current && (minEndDate ? current < minEndDate : false)
                        }
                      />
                    </Form.Item>
                  </Col>

                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item name="driver_id" label={t("pl_driver")}>
                      <Select
                        placeholder={t("pl_assign_driver")}
                        showArrow
                        showSearch
                        style={{ width: "170px" }}
                        name="driver_id"
                        optionFilterProp="children"
                        onChange={(value) => handleDriverFilter(value)}
                      >
                        {driverList?.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="status"
                      label={t("delivery_status")}
                      value={state?.status}
                    >
                      <Select
                        showArrow
                        placeholder={t("pl_delivery_status")}
                        onChange={(value) => handleDeliveryStatus(value)}
                      >
                        <Option key="Delivered" value="Delivered">
                          Delivered
                        </Option>
                        <Option key="Failed Delivery" value="Failed Delivery">
                          Failed Delivery
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Space>
              </Form>
            </div>
            <div className="btnscol btncolpack">
              <Space className="btnpack">
                <>
                  <Button
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="Apply"
                    onClick={handleApplyFilter}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <FilterOutlined style={{ fontSize: "16px" }} /> Apply
                      Filter
                    </span>
                  </Button>

                  {startDate ||
                  endDate ||
                  stateFilter?.status ||
                  stateFilter?.driver_id ? (
                    <Button
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Reset"
                      onClick={handleResetFilter}
                    >
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <UndoOutlined
                          style={{ fontSize: "16px", color: "#fff" }}
                        />{" "}
                        Reset
                      </span>
                    </Button>
                  ) : (
                    ""
                  )}
                </>

                <Button
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="DownloadPDF"
                  onClick={downloadCSV}
                  loading={btnLoading}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <DownloadOutlined style={{ fontSize: "16px" }} /> Download
                    PDF
                  </span>
                </Button>
              </Space>
            </div>
          </div> */}

          <Table
            scroll={{ x: 1000 }}
            rowKey={(record) => record.id}
            columns={columns.filter((col) => !col.hidden)}
            dataSource={employeeList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            onChange={handleTableChange}
          />
        </div>
      </section>
    </>
  );
};
export default BillingReportAdmin;
